import React from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { TextField } from "@episerver/ui-framework";

const DecimalField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, errors } = props;

    return (
        <Controller
            name={`extendedProperties[${index}].value`}
            control={control}
            rules={{
                required: {
                    value: !property.isNullable,
                    message: `${property.friendlyName} is required`,
                },
                pattern: {
                    value: /^[-]{0,1}(\d+(\.\d+)?)$/,
                    message: `${property.friendlyName} is invalid`,
                },
                min: {
                    value: -922337203685477,
                    message: `${property.friendlyName} is invalid`,
                },
                max: {
                    value: 922337203685477,
                    message: `${property.friendlyName} is invalid`,
                },
            }}
            render={({ field: { onChange, value } }) => (
                <TextField
                    id={`extendedProperties[${index}].value`}
                    type="text"
                    outlined
                    label={property.friendlyName}
                    helperText={errors.extendedProperties ? errors.extendedProperties[index]?.value?.message ?? property.description : property.description}
                    invalid={errors.extendedProperties && errors.extendedProperties[index]?.value ? true : false}
                    value={value ?? ""}
                    onChange={onChange}
                />
            )}
        />
    );
};

export default DecimalField;
